import { fmtMoney } from "@/lib/format";

const FunnelBar = ({ label, count, pct, tone = "#0A84FF" }) => (
  <div className="grid grid-cols-12 gap-4 items-center py-3 border-b border-[#1F1F1F] last:border-b-0">
    <div className="col-span-3 kpi-label">{label}</div>
    <div className="col-span-7">
      <div className="h-6 bg-[#0A0A0A] border border-[#262626] rounded-sm overflow-hidden relative">
        <div
          className="h-full transition-all duration-700"
          style={{ width: `${Math.max(2, pct || 0)}%`, background: `linear-gradient(90deg, ${tone}40 0%, ${tone} 100%)` }}
        />
        <span className="absolute inset-0 flex items-center px-3 text-[11px] font-mono-data text-white">
          {count} · {pct}%
        </span>
      </div>
    </div>
    <div className="col-span-2 text-right font-mono-data text-sm text-white">{count}</div>
  </div>
);

export const FunnelBlock = ({ funnel }) => {
  const c = funnel.counts || {};
  const conv = funnel.conversions || {};
  const t = funnel.totals || {};

  const stages = [
    { label: "Pitches Created", count: c.pitches_created || 0, pct: 100 },
    { label: "Pitches Submitted", count: c.pitches_submitted || 0, pct: conv.pitch_created_to_submitted || 0 },
    { label: "Meetings", count: c.meetings || 0, pct: conv.pitch_submitted_to_meeting || 0 },
    { label: "Opportunities", count: c.opportunities || 0, pct: conv.meeting_to_opportunity || 0 },
    { label: "Proposals", count: c.proposals || 0, pct: conv.opportunity_to_proposal || 0 },
    { label: "Wins", count: c.wins || 0, pct: conv.proposal_to_win || 0 },
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-testid="funnel-block">
      <div className="lg:col-span-2 bg-[#141414] border border-[#262626] rounded-sm p-5">
        <div className="kpi-label mb-3">/ ACTIVITY FUNNEL</div>
        {stages.map((s) => (
          <FunnelBar key={s.label} label={s.label} count={s.count} pct={Math.round(s.pct)} />
        ))}
      </div>
      <div className="bg-[#141414] border border-[#262626] rounded-sm p-5 space-y-4">
        <div>
          <div className="kpi-label">Total Pipeline Value</div>
          <div className="font-mono-data text-2xl text-white mt-1">{fmtMoney(t.total_pipeline_value)}</div>
        </div>
        <div>
          <div className="kpi-label">Total Proposals Value</div>
          <div className="font-mono-data text-2xl text-white mt-1">{fmtMoney(t.total_proposal_value)}</div>
        </div>
        <div>
          <div className="kpi-label">Total Wins Value</div>
          <div className="font-mono-data text-2xl text-[#32D74B] mt-1">{fmtMoney(t.total_wins_value)}</div>
        </div>
        <div className="grid grid-cols-2 gap-3 pt-3 border-t border-[#262626]">
          <div>
            <div className="kpi-label">Avg Deal Size</div>
            <div className="font-mono-data text-lg text-white mt-1">{fmtMoney(t.avg_deal_size)}</div>
          </div>
          <div>
            <div className="kpi-label">Win Rate</div>
            <div className="font-mono-data text-lg text-white mt-1">{(t.win_rate || 0)}%</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FunnelBlock;
